import { render, staticRenderFns } from "./MemberCreate.vue?vue&type=template&id=8cbf56bc&scoped=true"
import script from "./MemberCreate.vue?vue&type=script&lang=js"
export * from "./MemberCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbf56bc",
  null
  
)

export default component.exports